// Panel-side preference. "default" = explorer left / details right;
// "swapped" = explorer right / details left (the top bar and each panel's
// internals are unchanged — only the columns switch sides). Persisted so it
// survives reloads and applies across the Navigator and Settings routes.

export type PanelSide = "default" | "swapped";

const KEY = "cinedb.layout";

export function loadLayout(): PanelSide {
  if (typeof window === "undefined") return "default";
  return window.localStorage.getItem(KEY) === "swapped" ? "swapped" : "default";
}

export function saveLayout(v: PanelSide): void {
  try {
    window.localStorage.setItem(KEY, v);
  } catch {
    /* ignore */
  }
}
